var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.99829 15.1718V8.49929C2.99829 6.56601 4.56552 4.99878 6.49881 4.99878H19.5007C21.434 4.99878 23.0012 6.56601 23.0012 8.49929V8.99937C24.106 8.99937 25.0015 9.89493 25.0015 10.9997V14.9997C25.0015 16.1044 24.106 17 23.0012 17V17.5006C23.0012 19.4339 21.434 21.0011 19.5007 21.0011H8.82758C7.76655 21.0011 6.74899 20.5796 5.99873 19.8294L4.17004 18.0007C3.41978 17.2504 2.99829 16.2329 2.99829 15.1718ZM21.0009 8.49929V8.99937H18.0014C16.3443 8.99937 15.0009 10.3427 15.0009 11.9998V13.9995C15.0009 15.6566 16.3443 17 18.0014 17H21.0009V17.5006C21.0009 18.3292 20.3293 19.0008 19.5007 19.0008H8.82758C8.29706 19.0008 7.78828 18.7901 7.41315 18.415L5.58446 16.5863C5.20933 16.2111 4.99858 15.7024 4.99858 15.1718V8.49929C4.99858 7.67074 5.67026 6.99907 6.49881 6.99907H19.5007C20.3293 6.99907 21.0009 7.67074 21.0009 8.49929ZM23.0012 12.9994V13V14.9997H21.0009H18.0014C17.449 14.9997 17.0012 14.5519 17.0012 13.9995V11.9998C17.0012 11.4474 17.449 10.9997 18.0014 10.9997H21.0009H23.0012V12.9994ZM18.5006 11.9998C18.2244 11.9998 18.0005 12.2237 18.0005 12.4999V13.4997C18.0005 13.7759 18.2244 13.9998 18.5006 13.9998H19.5004C19.7766 13.9998 20.0005 13.7759 20.0005 13.4997V12.4999C20.0005 12.2237 19.7766 11.9998 19.5004 11.9998H18.5006Z",
    fill: "#FDEE2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.b7bdd714870e6bf96fb52f54958f4012.svg";
export { ForwardRef as ReactComponent };